<template>
    <div class="container-fluid h-100 sectionLogin bg-BAT-new-look">
        <div class="d-flex justify-content-center h-100 py-5">
            <div class="user_Login">
                <div class="d-flex justify-content-center mb-3">
                    <div class="brand_logo_container pt-3 pt-md-5 mb-3 mb-md-0">
                        <img src="/img/brand/logo_header_alaska_login.png" alt="Logo" />
                    </div>
                </div>
                <div class="text-login-new text-bat text-center">
                    <p>Te damos la bienvenida <strong>Conecta2</strong></p>
                    <h5 class="mb-0">¡Nos alegra tu visita!</h5>
                    <span>Por favor completa los datos para ingresar a la plataforma.</span>
                </div>
                <div class="d-flex justify-content-center form_container formLogin pt-3 mb-3 text-bat">
                    <div v-if="successMessage" class="alert alert-success mt-3">{{ successMessage }}</div>
                    <form @submit.prevent="submitForm" class="Login w-100">
                        <div class="boxFormLogin">
                            <label id="labelForm1" class="text-gray" for="user">Usuario / Cédula</label>
                            <div class="pass my-3">
                                <input id="user" v-model="form.identification_number" type="text" autofocus
                                    aria-describedby="userHelp" />
                            </div>
                        </div>

                        <div class="boxFormLogin mt-4">
                            <label id="labelForm2" class="text-gray" for="PassLogin">Contraseña</label>
                            <div class="pass my-3">
                                <input id="PassLogin" v-model="form.password" :type="passwordType" autocomplete="off" />
                                <div id="eye" class="eye" @click="togglePasswordVisibility"></div>
                            </div>
                        </div>

                        <div v-if="errorMessage.length" class="mt-2">
                            <ul>
                                <li class="error" v-for="(msg, index) in errorMessage" :key="index">{{ msg }}</li>
                            </ul>
                        </div>
                        <div class="check-box">
                            <div class="checkbox-record">
                                <input id="record" type="checkbox" v-model="form.remember" />
                                <label class="text-bat" for="record">Recordarme</label>
                            </div>
                            <div class="resPass">
                                <a href="/recordar-password">Olvidé mi contraseña</a>
                            </div>
                        </div>
                        <div class="buttonLogin">
                            <button id="login-ingresar" title="ingresar" class="rounded-3 mt-5 py-2" type="submit">
                              Ingresar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    data() {
        return {
            form: {
                identification_number: '',
                password: '',
                remember: false,
            },
            successMessage: null,
            errorMessage: [],
            passwordType: 'password',
        };
    },
    methods: {
        togglePasswordVisibility() {
            this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
        },
        async submitForm() {
            this.errorMessage = [];

            let isValid = true;

            if (!this.form.identification_number) {
                this.errorMessage.push('El campo Usuario/Cédula es obligatorio.');
                isValid = false;
            }

            if (!this.form.password) {
                this.errorMessage.push('El campo contraseña es obligatorio.');
                isValid = false;
            }

            if (!isValid) {
                return;
            }

            const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

            try {
                const response = await axios.post('/login', this.form, {
                    headers: {
                        'X-CSRF-Token': csrfToken
                    }
                });

                if (response.status === 200 || response.status === 204) {
                    this.errorMessage = [];
                    window.location.href = '/home-bat'; 
                }
            } catch (error) {
                if (error.response?.status === 302) {
                    this.errorMessage = ['Por favor verifique que haya escrito sus credenciales correctamente.'];
                } else {
                    this.errorMessage = [error.response?.data?.message || 'Error al iniciar sesión'];
                }
                this.successMessage = null;
            } 
        },
    },
};
</script>